import React from 'react';
import { useIntl, defineMessages } from 'react-intl-next';

import { useFeatureUsage } from '../../store/featureUsageStore';
import { Benefit } from '../Benefit';

const i18n = defineMessages({
	standardFeaturePageRestrictionsTitle: {
		id: 'end-of-trial-payment-modals.standard.feature.page-restrictions.title',
		defaultMessage: 'Page restrictions',
		description: 'Page restrictions title',
	},
	standardFeaturePageRestrictionsSubtitle: {
		id: 'end-of-trial-payment-modals.standard.feature.page-restrictions.subtitle',
		defaultMessage: 'Choose who can view or edit pages.',
		description: 'Page restrictions subtitle',
	},
});

export const PageRestrictions = () => {
	const intl = useIntl();

	const { isUsingPageRestrictions } = useFeatureUsage();

	return (
		<Benefit
			benefit={intl.formatMessage(i18n.standardFeaturePageRestrictionsTitle)}
			explanation={intl.formatMessage(i18n.standardFeaturePageRestrictionsSubtitle)}
			benefitTitle="page-restrictions"
			usingBenefit={isUsingPageRestrictions}
		/>
	);
};
